import { message } from "ant-design-vue";
import Cookies from "js-cookie";
import router from "@/router";
import axios from "axios";
import request from "./request";
const { getERPAccessToken } = require("@/utils/impersonation-session");

const GET_TOKEN_URL = "/user/get_token/";
const REFRESH_TOKEN_URL = "/user/refresh_token/";
const LOGIN_PATH = "/user/login";
const IMPERSONATION_KEY = "erp_impersonation";
const IMPERSONATION_ACCESS_KEY = "erp_impersonation_access";
const IMPERSONATION_REFRESH_KEY = "erp_impersonation_refresh";
let requestQueue = [],
  isRefreshing = false;
// console.log('[pppdwdwq',process.env.VUE_APP_NEW_URL)
const instance = axios.create({
  baseURL: process.env.VUE_APP_NEW_URL,
  timeout: 6000000,
});

instance.interceptors.request.use(
  (config) => {
    if (!config.url.includes(GET_TOKEN_URL) && !config.url.includes(REFRESH_TOKEN_URL)) {
      const token = getERPAccessToken(Cookies.get("access"), sessionStorage.getItem(IMPERSONATION_ACCESS_KEY));
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
    }

    config.headers["Accept-Language"] = Cookies.get("language") || "zh-Hans";
    // console.info("Send request:", config);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (!error.response) return Promise.reject(error);
    console.error("Request error:", error.response);

    if (error.response.status >= 500) {
      message.error("服务器错误");
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !error.config.url.includes(REFRESH_TOKEN_URL)) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          requestQueue.push({
            resolve: () => resolve(instance(error.config)),
            reject,
          });
        });
      } else {
        isRefreshing = true;
        return refreshToken()
          .then((data) => {
            Cookies.set("access", data.access);
            requestQueue.forEach((item) => item.resolve());
            requestQueue = [];

            return instance(error.config);
          })
          .catch((error) => {
            requestQueue.forEach((item) => item.reject(error));
            requestQueue = [];
            if (error.response && error.response.status === 401) {
              redirectLogin();
              message.error("令牌过期, 请重新登录");
            } else {
              redirectLogin();
            }
            return Promise.reject(error);
          })
          .finally(() => {
            isRefreshing = false;
          });
      }
    }

    if (error.response.data.detail) {
      message.error(error.response.data.detail);
    }
    return Promise.reject(error);
  }
);

function refreshToken() {
  return request({ url: REFRESH_TOKEN_URL, method: "post", data: { refresh: sessionStorage.getItem(IMPERSONATION_REFRESH_KEY) || Cookies.get("refresh") } });
}

function redirectLogin() {
  const isImpersonating = !!sessionStorage.getItem(IMPERSONATION_ACCESS_KEY);
  if (!isImpersonating) {
    Cookies.remove("access");
    Cookies.remove("refresh");
    localStorage.removeItem(IMPERSONATION_KEY);
  }
  sessionStorage.removeItem(IMPERSONATION_ACCESS_KEY);
  sessionStorage.removeItem(IMPERSONATION_REFRESH_KEY);
  sessionStorage.removeItem(IMPERSONATION_KEY);
  router.push(LOGIN_PATH);
}

function request1(item) {
  let { data = {} } = item;
  for (let key in data) {
    if (data[key] === undefined) delete data[key];
  }

  return instance(item);
}
export default request1


request1.post = function (item) {
  return request1({
    ...item,
    method: 'post'
  })
}

request1.get = function (item) {
  return request1({
    ...item,
    method: 'get'
  })
}
